// @core/api/endpoints/team/decline_team_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeclineTeamInvitationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Decline team invitation
 * Declines a pending team invitation. The invitation is marked as declined and the user does not join the team.
 */
export async function DeclineTeamInvitation(
  invitation_id: string,
  data: DeclineTeamInvitationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invitations/:invitation_id/decline`;
  requestPath = requestPath.replace(':invitation_id', encodeURIComponent(invitation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
